import _Model from "./_Model";
import DeviceWithQuantity from "./DeviceWithQuantity";

export default class SlottedAdditionalDevice extends _Model {
  constructor(json) {
    super(json);
    this.layer = SlottedAdditionalDevice.getMappedOrDefault(json, 'layer', 0, v => parseInt(v));
    this.possibleDevices = SlottedAdditionalDevice.getMappedOrDefault(json, 'possibleDevices', [], data => (data || []).map(d => new DeviceWithQuantity(d || {})));
    this.selectedDeviceId = SlottedAdditionalDevice.getOrDefault(json, 'selectedDeviceId', null);
  }

  get selectedDevice() {
    const selectedDevice = this.possibleDevices.find(d => d.id.localeCompare(this.selectedDeviceId) === 0);
    if (!!selectedDevice) {
      return selectedDevice;
    }
    return this.possibleDevices
      .find((v, i) => i === 0);
  }
}
